import { render } from "./RecommendPointRank111.vue?vue&type=template&id=e2485298&scoped=true"
import script from "./RecommendPointRank111.vue?vue&type=script&lang=js"
export * from "./RecommendPointRank111.vue?vue&type=script&lang=js"

import "./RecommendPointRank111.vue?vue&type=style&index=0&id=e2485298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2485298"]])

export default __exports__